import React from "react";
import { Form } from "semantic-ui-react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { EditEntity } from "../../../components/common/edit-entity";
import {
  FormdataManager,
  getInitialState,
} from "../../../components/common/formdata";
import { ErrorWrap } from "../../../helpers/error";
import {
  clearContractError,
  updateContract,
} from "../../../redux/modules/contract";
import { t } from "../../../constant/translations";
import { InlineDateInput } from "../../../components/common/inline-date-input";

const ContractFormComponent = ({ entity, error, ...props }) => {
  const manager = FormdataManager.useState(getInitialState(entity)).withError(
    error
  );

  return (
    <EditEntity
      manager={manager}
      header={t("contract.edit_contract")}
      entity={entity}
      error={error}
      {...props}
      trigger_props={
        props.triggerElement || props.trigger_props
          ? props.trigger_props
          : {
              content: t("contract.edit_contract"),
              basic: true,
              size: "small",
            }
      }
    >
      <Form.Field>
        <label>{t("contract.start_date")}</label>
        <InlineDateInput
          value={manager.getValue("start_date")}
          onChange={(v) => manager.setValue("start_date", v)}
        />
      </Form.Field>
      <Form.Field>
        <label>{t("contract.end_date")}</label>
        <InlineDateInput
          value={manager.getValue("end_date")}
          onChange={(v) => manager.setValue("end_date", v)}
        />
      </Form.Field>
      <Form.Input
        label={t("contract.fee_formula")}
        {...manager.getAttributes("fee_formula")}
      />
      <Form.TextArea
        label={t("contract.notes")}
        {...manager.getAttributes("notes")}
      />
    </EditEntity>
  );
};

function mapStateToProps(state) {
  return {
    error: ErrorWrap.fromError(state.contract.error),
    loading: state.contract.pending,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      update: updateContract,
      create: () => () => {},
      clearError: clearContractError,
    },
    dispatch
  );
}

export const ContractForm = connect(
  mapStateToProps,
  mapDispatchToProps
)(ContractFormComponent);
